import React from 'react';
import styled, { css, withTheme } from 'styled-components';
import thronThumbnailResize from '../utils/thronThumbnailResize';
import remToPixels from '../utils/remToPixels';
import RenderOnMobile from './responsive/RenderOnMobile';
import RenderOnTablet from './responsive/RenderOnTablet';
import themeResponsiveProperty from "./responsive/themeResponsiveProperty";
import CardTitle from './CardTitle';

function resizeCover(cover, large) {
  if (cover === null) {
    return cover;
  }

  const size = large
    ? { width: window.innerWidth * window.devicePixelRatio, height: remToPixels(29) }
    : { width: window.innerWidth * window.devicePixelRatio * 0.6 };

  return thronThumbnailResize(cover, size);
}

const PageHeader = withTheme(({ cover = null, crumbs, title, preTitle, large, backUrl = null, children, ...props }) => (
  <React.Fragment>
    <RenderOnMobile>
      <ContainerMobile cover={resizeCover(cover, true)}>
        <CardTitle>{preTitle && <span>{preTitle} / </span>}{title}</CardTitle>
      </ContainerMobile>

      <RenderOnTablet>
        <hr style={{ margin: '0 1.25rem' }} />
      </RenderOnTablet>

      <div style={{
        marginTop: themeResponsiveProperty(null, '1.25rem')(props),
        marginBottom: '0',
      }}>
        {children}
      </div>
    </RenderOnMobile>

    <RenderOnTablet>
      <ContainerTablet cover={resizeCover(cover, large)} large={large !== undefined} {...props}>
        <span>{crumbs.join(' / ')}</span>

        <h1>
          {preTitle && (
            <React.Fragment>
              <small>{preTitle}</small>
              <br />
            </React.Fragment>
          )}
          {title}
        </h1>

        {children}
      </ContainerTablet>
    </RenderOnTablet>
  </React.Fragment>
));

export default PageHeader;

PageHeader.MenuContainer = styled.div`
  position: relative;
  padding: ${themeResponsiveProperty(null, '0 3rem')};

  ${props => props.theme.isTablet && css`
    background: rgb(37,37,37);
    background: linear-gradient(90deg, ${props => props.theme.tertiaryBackgroundColorNegative} 45%, rgba(255,255,255,0) 60%),
                rgba(255,255,255,.3);
  `};
`;

const ContainerMobile = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;

  ${props => props.cover !== null ? css`
    height: 8.3125rem;
    padding: .625rem;
    background: url(${props => props.cover});
    background: linear-gradient(90deg, rgba(0,0,0,.3) 65%, rgba(0,0,0,.3) 100%),
                transparent url(${props => props.cover}) no-repeat center center;
    background-size: 100%,
                     cover;
    color: #fff;
  ` : css`
    margin: 0 1rem .75rem;
    padding: .75rem 0;
    border-bottom: .0625rem solid rgb(0 0 0 / .25);
    text-transform: uppercase;
  `};

  > h2 {
    margin-top: 0;
    margin-bottom: 0;
    padding: 0 1rem;
    text-transform: uppercase;
    font-size: 1rem;

    > span {
      opacity: .4;
    }
  }
`;

const ContainerTablet = styled.div`
  background: url(${props => props.cover});
  background: linear-gradient(90deg, rgba(0,0,0,1) 45%, rgba(0,0,0,.3) 65%, rgba(0,0,0,.3) 100%),
              #323334 url(${props => props.cover}) no-repeat right center;
  background-size: 100%,
                   60%;

  ${({ large }) => large && css`
    height: 29rem;
    background: radial-gradient(farthest-corner at 100% 100%, rgba(37,37,37,0) 60%, rgba(0,0,0,.8) 100%),
                #323334 url(${props => props.cover}) no-repeat right center;
    background-size: cover, cover;
  `};

  > span {
    display: inline-block;
    padding: 3rem 3rem 0;

    ${({ smallTitle }) => smallTitle && css`
      padding-top: 1.5rem;
    `};

    ${({ compact }) => compact && css`
      padding-top: 1rem;
    `};

    color: #767676;
  }

  > h1 {
    margin-bottom: 0;
    padding: 0 3rem 3rem;

    ${({ smallTitle }) => smallTitle && css`
      padding-top: 1.25rem;
      padding-bottom: 1.5rem;
      font-size: 1.125rem;
    `};

    ${({ compact }) => compact && css`
      padding-bottom: 2rem;
    `};

    color: #fff;
    text-transform: uppercase;

    > small {
      font-size: 1rem;
      color: rgba(255,255,255,.8);
      text-transform: initial;
    }
  }
`;
